import React from 'react';

const NotFound: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-red-500">
          404 - Page Not Found
        </h1>
        <p className="mt-4 text-lg text-gray-700">
          The page you are looking for does not exist.
        </p>
        <p className="mt-2 text-sm text-gray-500">
          Please check the URL or return to the home page.
        </p>
      </div>
    </div>
  );
};

export default NotFound;
